import React from 'react'

import { TestimonyContainer, Title, VideoContainer } from './styles'

const Testimony = () => {
  const testimonyVideos = [
    {
      imagen: '/images/aboutus/yt1.jpg',
      url: 'https://www.youtube.com/shorts/qWjkfyoXlUM',
    },
    {
      imagen: '/images/aboutus/yt2.jpg',
      url: 'https://youtube.com/shorts/vTvQwkLHSvI?si=P01a83ZygASAf0ML',
    },
    {
      imagen: '/images/aboutus/yt3.jpg',
      url: 'https://youtu.be/-qwUeuZKQjA?si=7PipRY2qPA-qbFrj',
    },
  ]

  return (
    <TestimonyContainer>
      <Title> Testimonios </Title>
      <VideoContainer>
        {testimonyVideos.map((video, index) => (
          <a key={index} href={video.url} target="_blank" rel="noopener noreferrer">
            <img
              src={video.imagen}
              alt={`Testimonio ${index + 1}`}
              width="560"
              height="315"
              loading="lazy"
            />
          </a>
        ))}
      </VideoContainer>
    </TestimonyContainer>
  )
}

export default Testimony
